type ReplayFrame = {
  filename?: string
  abs_path?: string
  function?: string
}

type ReplayException = {
  type?: string
  value?: string
  stacktrace?: { frames?: ReplayFrame[] }
}

export type ReplaySampleEvent = {
  message?: string
  exception?: { values?: ReplayException[] }
  breadcrumbs?: Array<{ message?: string; data?: Record<string, unknown> }>
}

const SKIP_REPLAY_PATTERN =
  /userway|widgetapp|widget_app|\[object HTMLLinkElement\]|\[object HTMLScriptElement\]|Kt\.services\.hasOwnProperty/i

function frameText(frame: ReplayFrame): string {
  return [frame.filename, frame.abs_path, frame.function].filter(Boolean).join(' ')
}

function eventHaystack(event: ReplaySampleEvent): string {
  const parts: string[] = []
  if (event.message) parts.push(event.message)

  for (const exception of event.exception?.values ?? []) {
    if (exception.type) parts.push(exception.type)
    if (exception.value) parts.push(exception.value)
    for (const frame of exception.stacktrace?.frames ?? []) {
      parts.push(frameText(frame))
    }
  }

  for (const crumb of event.breadcrumbs ?? []) {
    if (crumb.message) parts.push(crumb.message)
    const url = crumb.data?.url
    if (typeof url === 'string') parts.push(url)
  }

  return parts.join('\n')
}

/** Return false so Session Replay does not record this error. The error itself is still sent. */
export function shouldSampleReplayForError(event: ReplaySampleEvent): boolean {
  return !SKIP_REPLAY_PATTERN.test(eventHaystack(event))
}
